<style lang="scss">
@media only screen and (max-width: 400px) {
  .app-stepper .v-stepper--vertical {
    .v-stepper__content {
      border-left: none !important;
      margin: -12px 0;
      padding: 16px 16px 16px 16px !important;
    }
  }

  .v-alert__wrapper {
    display: flex;
    flex-direction: column;
  }
}
</style>

<template>
  <v-container :fluid="$vuetify.breakpoint.mdAndDown" class="app-stepper">
    <v-row v-if="$store.state.confirmed_at">
      <v-col>
        <base-card dark>
          <v-card-text>
            <div class="d-flex align-center">
              <v-icon left x-large>mdi-lock</v-icon>
              <div class="ml-md-3">
                <div>
                  {{
                    $t(
                      "Preferences for this apartment have already been confirmed {0} and it's not possible to make changes anymore.",
                      [$store.state.confirmed_at],
                    )
                  }}
                </div>
                <div v-t="'Please contact us if you would like to clarify.'" />
              </div>
            </div>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>
    <v-row justify="center" :key="$store.state.apartment_id">
      <v-col
        cols="12"
        md="4"
        xl="3"
        v-if="$store.state.step !== 'Summary' || $vuetify.breakpoint.smAndDown"
      >
        <Sidebar />
      </v-col>

      <v-col cols="12" :md="$store.state.step !== 'Summary' ? 8 : 12" order-md="first">
        <v-card tile class="mb-5">
          <v-card-text>
            <Introduction />
          </v-card-text>
        </v-card>
        <VerticalStepper class="mb-5" />
        <!-- <v-btn
          x-small
          text
          @click="$store.dispatch('reset')"
          :loading="$store.state.loading.includes('reset')"
        >
          <span v-t="'Reset'" />
        </v-btn> -->
      </v-col>
    </v-row>
    <div class="text-subtitle-2 mt-3 secondary-text font-weight-light">
      <p>
        * Sisestatud andmed säilivad ka peale selle akna sulgemist. Poolelioleva vormi täitmist saad
        jätkata, kui sisestad naastes sama e-postiaadressi <i>{{ $store.state.email }}</i> või naased
        sellele veebiaadressile:
        <br />
        <i>{{ url }}</i>
      </p>
    </div>
  </v-container>
</template>

<script>
import Introduction from "../components/introduction/Introduction";
import Sidebar from "../components/sidebar/Sidebar";

import VerticalStepper from "../components/stepper/VerticalStepper";
import ObjectDetails from "@/components/stepper/steps/ObjectDetails";
import { steps, components } from "@/components/stepper/stepper";
export default {
  components: {
    ObjectDetails,
    VerticalStepper,
    ...components,
    Sidebar,
    Introduction,
  },

  data() {
    return {
      steps,
      iteration: 1,
      tooltipText: "Kliki, et kopeerida vahemällu",
    };
  },

  computed: {
    url() {
      return window.location;
    },
  },

  mounted() {
    this.$store.dispatch("checkValidity");
  },

  methods: {
    async initStepper() {
      const response = await this.axios.post("init", this.$route.query);
      const selection = response.data.selection;
      this.$store.dispatch("setFromDatabase", selection);
    },
  },
};
</script>
